import { queryString, request } from '../../../shared/api/httpClient';
import type { Store } from '../../auth';
export const storesApi = {
  list: (userId: string, signal?: AbortSignal) => request<{ stores: Store[] }>('/stores' + queryString({ user_id: userId }), { signal }),
};
